
import { RegionMemberActionTypes, RegionMemberActions } from '../actions/region-member.actions';

export interface State {
  isLoaded: boolean;
  isLoading: boolean;
  entities: any;
}

export const initialState: State = {
  isLoaded: false,
  isLoading: false,
  entities: null
};

export function reducer(state: State = initialState, action: RegionMemberActions): State {
  switch (action.type) {
    case RegionMemberActionTypes.ReadCompanyMember:
      return {...state, isLoading: true, isLoaded: false};
    case RegionMemberActionTypes.ReadCompanyMemberSuccess:
      return {...state, isLoading: false, isLoaded: true, entities: action.payload };
    case RegionMemberActionTypes.ReadCompanyMemberFail:
      return {...state, isLoading: false, isLoaded: true};
    case RegionMemberActionTypes.UpdateCompanyMember:
      return {...state, isLoading: true, isLoaded: false};
    case RegionMemberActionTypes.UpdateCompanyMemberFail:
      return {...state, isLoading: false, isLoaded: true};
    case RegionMemberActionTypes.ActivateCompanyMember:
      return {...state, isLoading: true, isLoaded: false};
    case RegionMemberActionTypes.ActivateCompanyMemberFail:
      return {...state, isLoading: false, isLoaded: true};
    case RegionMemberActionTypes.CheckCompanyMember:
      return {...state, isLoading: true, isLoaded: false};
    case RegionMemberActionTypes.CheckCompanyMemberFail:
      return {...state, isLoading: false, isLoaded: true};

    default:
      return state;
  }
}

export const getRegionMemberState = (state: State) => state;